import style from '../assets/complianceStyle';
import logo from '../assets/compliassistlogob64';
import sanitize from '../utils/sanitize';
import { generateFooterTemplate, generateHeaderTemplate } from './headerFooter';

const HTML_TEMPLATES = {
  bendData: (formattedCharts, formattedChartsByState, searchCriteria, groupBy, displayChanges) => {
    const { categories = [], charts = [], states = [], searchText = '' } = searchCriteria;

    return `
      <section class="apcia-white-Section-section">
        <div class="apcia-container-lg-Container">
          <section class="apcia-logo">
            <img src="${logo}" alt="Compliassist logo">
          </section>
          <div>
            <div>
              <div class="apcia-container">
                <div class="apcia-headingWrapper">
                  <h4 class="apcia-4-bolder-primaryGray-Heading-heading">${
                    displayChanges ? 'Search Criteria - Recent Changes' : 'Search Criteria'
                  }</h4>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">Category:</p>
                  <p class="apcia-data">${
                    categories.length > 0
                      ? categories.map(c => c.categoryDescription || c.CategoryDescription).join(', ')
                      : 'All Categories'
                  }</p>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">Chart(s):</p>
                  <p class="apcia-data">${
                    charts.length > 0
                      ? charts.map(c => c.chartTitle || c.ChartTitle).join(', ')
                      : 'All Charts'
                  }</p>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">State(s):</p>
                  <p class="apcia-data">${
                    states.length > 0
                      ? states.map(c => c.stateDescription || c.StateDescription).join(', ')
                      : 'All States'
                  }</p>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">Search Text:</p>
                  <p class="apcia-data">${searchText || ''}</p>
                </div>
              </div>
              ${
                groupBy === 'state'
                  ? `<div>
                  <div>
                    ${formattedCharts
                      .map(
                        chart =>
                          `<div class="apcia-1fygsgo">
                        <div>
                          <div class="apcia-container">
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Chart Name:</p>
                              <div class="apcia-data">${chart.chartTitle}</div>
                            </div>
                            ${
                              displayChanges
                                ? ''
                                : `<div class="apcia-gridContainer">
                              <p class="apcia-label">Chart Description:</p>
                              <div class="apcia-data">${chart.chartDescription}</div>
                            </div>
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Chart Notes:</p>
                              <div class="apcia-data">
                                <div class="sanitized">
                                  ${sanitize(chart.chartNotes)}
                                </div>
                              </div>
                            </div>
                            <div class="apcia-1fygsgo">
                              <div class="apcia-gridContainer">
                                <p class="apcia-label">Contact:</p>
                                <div class="apcia-data">
                                  <div>
                                    <p class="apcia-data">${chart.contact.fullName}</p>
                                    <p class="apcia-data">${chart.contact.phone}</p>
                                    <a href="mailto:${
                                      chart.contact.email
                                    }" class="apcia-4-bold-primaryBlue-Heading-data">${
                                    chart.contact.email
                                  }</a>
                                  </div>
                                </div>
                              </div>
                            </div>`
                            }
                          </div>
                        </div>
                      </div>`
                      )
                      .join('')}
                  </div>
                  <div>
                  ${formattedChartsByState
                    .map(
                      state =>
                        `<div class="apcia-1fygsgo">
                      <div class="apcia-container">
                        <div class="apcia-headingWrapper">
                          <h4 class="apcia-4-bolder-primaryGray-Heading-heading2">${
                            state.chartState
                          }</h4>
                        </div>
                        ${state.charts
                          .map(
                            chart =>
                              `<div class="apcia-gridContainer2">
                              <p class="apcia-label">Chart Name:</p>
                              <div class="apcia-data">${chart.chartTitle}</div>
                            </div>
                            ${chart.topics
                              .map(
                                topic => `
                              <div class="apcia-gridContainer">
                                <p>${topic.chartTopic}</p>
                                <div class="sanitized ">${sanitize(
                                  displayChanges
                                    ? topic.recentChanges || topic.RecentChanges || topic.details
                                    : topic.details
                                )}</div>
                              </div>
                            `
                              )
                              .join('')}
                            ${
                              displayChanges
                                ? ''
                                : `<div class="apcia-gridContainer">
                              <p>State Notes: </p>
                              <div class="sanitized ">
                                ${sanitize(
                                  chart.topics.length
                                    ? chart.topics[chart.topics.length - 1].stateNotes
                                    : ''
                                )}
                              </div>
                            </div>`
                            }`
                          )
                          .join('')}
                      </div>
                    </div>`
                    )
                    .join('')}
                  </div>
                </div>`
                  : formattedCharts
                      .map(
                        chart => `
                  <div>
                    <div class="apcia-1fygsgo">
                      <div>
                        <div class="apcia-container">
                          <div class="apcia-gridContainer">
                            <p class="apcia-label">Chart Name:</p>
                            <div class="apcia-data">${chart.chartTitle}</div>
                          </div>
                          ${
                            displayChanges
                              ? ''
                              : `<div class="apcia-gridContainer">
                            <p class="apcia-label">Chart Description:</p>
                            <div class="apcia-data">${chart.chartDescription}</div>
                          </div>
                          <div class="apcia-gridContainer">
                            <p class="apcia-label">Chart Notes:</p>
                            <div class="apcia-data">
                              <div class="sanitized">
                                ${sanitize(chart.chartNotes)}
                              </div>
                            </div>
                          </div>
                          <div class="apcia-1fygsgo">
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Contact:</p>
                              <div class="apcia-data">
                                <div>
                                  <p class="apcia-data">${chart.contact.fullName}</p>
                                  <p class="apcia-data">${chart.contact.phone}</p>
                                  <a href="mailto:${
                                    chart.contact.emailAddress
                                  }" class="apcia-4-bold-primaryBlue-Heading-data">
                                    ${chart.contact.emailAddress}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>`
                          }
                        </div>
                      </div>
                    </div>
                    ${chart.states
                      .map(
                        state => `
                      <div class="apcia-1fygsgo">
                        <div class="apcia-container">
                          <div class="apcia-headingWrapper">
                            <h4 class="apcia-4-bolder-primaryGray-Heading-heading">${
                              state.chartState
                            }</h4>
                          </div>
                          ${state.topics
                            .map(
                              topic => `
                            <div class="apcia-gridContainer">
                              <p>${topic.chartTopic}</p>
                              <div class="sanitized ">${sanitize(
                                displayChanges
                                  ? topic.recentChanges || topic.RecentChanges || topic.details
                                  : topic.details
                              )}</div>
                            </div>
                          `
                            )
                            .join('')}
                          ${
                            displayChanges
                              ? ''
                              : `<div class="apcia-gridContainer">
                            <p>Notes: </p>
                            <div class="sanitized ">
                              ${sanitize(
                                state.topics.length
                                  ? state.topics[state.topics.length - 1].stateNotes
                                  : ''
                              )}
                            </div>
                          </div>`
                          }
                        </div>
                      </div>
                    `
                      )
                      .join('')}
                  </div>
              `
                      )
                      .join('')
              }
            </div>
            <p class="apcia-text">
              <b>Disclaimer:</b> This compliance resource was prepared by American Property Casualty Insurance Association (APCIA) as a research aid only. 
              Reasonable attempts have been made to ensure that the content is accurate and current as of its publication date. However, 
              you should independently verify any statutory or regulatory language referenced herein. This compliance resource is not intended as, 
              and should not be construed to constitute, legal or regulatory advice and use of the resource(or any part thereof) does not establish an attorney / client relationship. 
              Transmission or reproduction of the compliance resource for commercial purposes or for distribution as legal or regulatory advice or using it to serve as, substitute for, 
              supplement, or replace the operating procedures, decision rules, guidelines, or advice of your Company is strictly prohibited. 
              Non - commercial transmission or reproduction of this resource for limited, internal use is permissible, but must include this Disclaimer.
            </p>
          </div>
        </div>
      </section>
    `;
  },
};

export function generateHTMLString(
  formattedCharts,
  formattedChartsByState,
  searchCriteria,
  groupBy,
  displayChanges = false
) {
  return `
    ${generateHeaderTemplate(style)}
    ${HTML_TEMPLATES.bendData(
      formattedCharts,
      formattedChartsByState,
      searchCriteria,
      groupBy,
      displayChanges
    )}
    ${generateFooterTemplate()}
  `;
}